import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AuthService } from './api/auth.service';
import { CategoriesService } from './api/categories.service';
import { DefaultService } from './api/default.service';
import { EstablishmentsService } from './api/establishments.service';
import { MenuCategoriesService } from './api/menu-categories.service';
import { MenuCategoryProductsService } from './api/menu-category-products.service';
import { MenusService } from './api/menus.service';
import { PaymentsService } from './api/payments.service';
import { PricesService } from './api/prices.service';
import { ProductsService } from './api/products.service';
import { StatisticsService } from './api/statistics.service';
import { TranslationsService } from './api/translations.service';
import { UsersService } from './api/users.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
